module.exports = __webpack_public_path__ + "static/media/coupon-delivery.68bde8bf.png";